import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-16 md:py-24" data-id="element-109">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="pl-6 md:pl-10 border-l-4 border-sage" data-id="element-111">
          <p className="text-lg md:text-xl text-brown-body leading-relaxed mb-6" data-id="element-112">
            En Estados Unidos, la primera respuesta ante cualquier malestar
            infantil es la química sintética. Pero como madre o padre
            consciente, sabes que el cuerpo de un niño es delicado. El uso
            excesivo de fármacos para cada pequeña molestia puede sobrecargar su
            hígado inmaduro y debilitar su sistema inmune a largo plazo.
          </p>
          <p className="text-lg md:text-xl text-brown-body leading-relaxed font-medium" data-id="element-113">
            El problema no es la medicina, es la falta de herramientas en casa.
            Te han hecho creer que no puedes manejar una fiebre leve o una
            dentición dolorosa por tu cuenta, obligándote a depender de
            productos llenos de "ingredientes inactivos" que no querrías ni
            pronunciar.
          </p>
        </motion.div>
      </div>
    </section>;
}